import Typography from "@mui/material/Typography";

import RouterLink from "../../../../common/components/RouterLink";
import { RouteEnum } from "../../../../common/models/enums";
import GateGuardDataHubIcon from "../icons/GateGuardDataHubIcon";
import DataHubGridItem from "./DataHubGridItem";
import { IModelGridItemProps } from "./GasLeakGridItem";

const GateGuardGridItem = ({ nonAdmin }: IModelGridItemProps): JSX.Element => {
  return (
    <RouterLink
      to={
        nonAdmin ? RouteEnum.SensoryTelemetryAgg : RouteEnum.TelemetryGateGuard
      }
    >
      <DataHubGridItem>
        <GateGuardDataHubIcon />
        <Typography variant="body2Bold">Gate Guard</Typography>
      </DataHubGridItem>
    </RouterLink>
  );
};

export default GateGuardGridItem;
